export const defaultMapOptions = {
  styles: [
    {
      featureType: 'poi.business',
      elementType: 'labels.icon',
      stylers: [
        {
          visibility: 'off',
        },
      ],
    },
  ],
};

export const defaultPolygonOptions = {
  fillColor: '#193340',
  fillOpacity: 0.13,
  strokeColor: '#193340',
  strokeWeight: 2,
};
